export default __webpack_public_path__ + "static/media/3.50cc2a4b.webp";